<div class="modal-header ">
    <h4 class="modal-title m-0">Internal links suggestions</h4>
    <i class="bi bi-x-lg" role="button" (click)="applyChanges()"></i>
</div>
<div class="modal-body">
    <ng-container *ngIf="isTokenExpire">
        <div class="col-12 d-flex justify-content-center align-items-center">
            <div class="col-4 col-xxl-4 profile-wrapper m-2">
                <div class="card profile-card" style="height: 14rem;">
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <img src="../../../assets/images/gsc.png" class="me-3" height="40" width="40" alt="">
                                <h2 class="txt-black p-0 m-0">Google Search Console</h2>
                            </div>
                            <div class="">
                                <div>
                                </div>
                                <div><button class="btn btn-primary" (click)="authorize()">Connect</button>
                                </div>
                            </div>
                        </div>
                        <p class="px-2 mt-4 text-secondary fs-6" style="padding: 20px;">
                            Integrate your Google search console with Strell and effortlessly monitor your sites traffic.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
    </ng-container>

    <ng-container *ngIf="!isTokenExpire">
        <div class="col-3">
            <label class="fw-600 fs-14 Neutral">Sites</label>
            <mat-form-field appearance="outline" class="w-100 country-input" [ngClass]="theme ? '': 'dark-input' ">
                <mat-select [(ngModel)]="selected" panelClass="{{selectMenu}}" (selectionChange)="changeData($event)"
                    [disableOptionCentering]="true">
                    <mat-option *ngFor="let data of siteData" [value]="data.siteUrl">{{data.siteUrl}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div style="height: 400px; overflow: scroll;" *ngIf="queryData?.length>0">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Query</th>
                        <th scope="col">Page Url</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of queryData;let i = index">
                        <th scope="row">{{i + 1}}</th>
                        <td>{{row.keys[0]}}</td>
                        <td>{{row.keys[1]}}</td>
                        <th scope="col">
                            <div class="d-flex justify-content-center">
                                <mat-slide-toggle color="primary" [(ngModel)]="row.isChecked"></mat-slide-toggle>
                            </div>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="" *ngIf="queryData.length == 0">
            <p class="text-center">No Data Available</p>
        </div>
    </ng-container>


</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="applyChanges()">Apply</button>
    <button type="button" class="btn btn-outline-primary" (click)="closeModal()">Close</button>
</div>